import * as types from "./actionTypes";

export const postNonverbalImmediacyTest = (answers, name) => ({
  type: types.POST_NONVERBAL_IMMEDIACY_TEST,
  payload: { answers, name },
});

export const postExposureBasedMemoryTest = (answers, name) => ({
  type: types.POST_EXPOSURE_BASED_MEMORY_TEST,
  payload: { answers, name },
});

export const postDiscAssessmentTest = (answers, name) => ({
  type: types.POST_DISC_ASSESSMENT_TEST,
  payload: { answers, name },
});

export const postBig5PersonalityTest = (answers, name) => ({
  type: types.POST_BIG_5_PERSONALITY_TEST,
  payload: { answers, name },
});

export const big5PersonalityTestSubmitted = () => ({
  type: types.BIG_5_PERSONALITY_TEST_SUBMITTED,
});

export const exposureBasedMemoryTestSubmitted = () => ({
  type: types.EXPOSURE_BASED_MEMORY_TEST_SUBMITTED,
});

export const nonverbalImmediacyTestSubmitted = () => ({
  type: types.NONVERBAL_IMMEDIACY_TEST_SUBMITTED,
});

export const discAssessmentTestSubmitted = () => ({
  type: types.DISC_ASSESSMENT_TEST_SUBMITTED,
});

export const setDiscAssessmentTestLoading = (isLoading) => ({
  type: types.DISK_ASSESSMENT_TEST_LOADING,
  payload: isLoading,
});
